<template>
  <g
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    @mousedown="$emit('mousedown', $event)"
  >
    <defs>
      <marker
        id="arrow"
        markerWidth="10"
        markerHeight="10"
        refX="0"
        refY="3"
        orient="auto"
      >
        <path d="M0,0 L0,6 L9,3 z" :fill="link.color || 'blue'" />
      </marker>
    </defs>
    <!-- <path
      :d="curve"
      :style="largeStrokeStyle"
      stroke-width="8"
      fill="none"
    />
    <path
      :d="curve"
      style="stroke:rgb(0,0,0);"
      stroke-width="2"
      fill="none"
    /> -->
    <polyline
      :points="curve"
      stroke-width="2"
      fill="white"
      :stroke="link.color || 'blue'"
      marker-end="url(#arrow)"
    />
  </g>
</template>
<script>
import Link from "../models/Link";
import Node from "../models/Node";

export default {
  name: "DiagramLink",
  props: {
    link: { type: Link, required: true },
    linkList:{type:Object,require:false},
    nodeStart: { type: Node, required: true },
    nodeEnd: { type: Node, required: true },
    selected: { type: Boolean, default: false },
  },

  data: () => ({
    hovered: false,
  }),

  computed: {
    startCoordinates() {
      return this.nodeStart.getPortCoordinates("out", this.link.start_port);
    },
    endCoordinates() {
      return this.nodeEnd.getPortCoordinates("in", this.link.end_port);
    },
    x1() {
      return this.startCoordinates.x - 2;
    },

    y1() {
      return this.startCoordinates.y;
    },

    x2() {
      return this.endCoordinates.x + 1;
    },

    y2() {
      return this.endCoordinates.y;
    },

    curve() {
      return this.linkList[this.link.id].path
    },

    largeStrokeStyle() {
      if (this.selected) {
        return this.hovered
          ? "stroke:rgba(0,0,255,0.6);"
          : "stroke:rgba(0,0,255,0.4);";
      }
      return this.hovered
        ? "stroke:rgba(255,0,0,0.5);"
        : "stroke:rgba(255,0,0,0.0);";
    },
  },
};
</script>
